import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { TmsWebBaseEditService } from '../../base';
import {
  BondedStock,
  BondedStockAnalysis,
  BondedStockTransaction,
  SalesDespatchItemForStockItem,
  StockItemHeader,
  UnBondedStockAnalysis,
} from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class BondedStockService extends TmsWebBaseEditService<BondedStock, BondedStock> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('BondedStock', $localize`Bonded Stock`);
  }

  getBondedStockTransactions(id: string): Observable<BondedStockTransaction[]> {
    return this.httpService.get<BondedStockTransaction[]>(`${this.apiUrl}/GetBondedStockTransactions?id=${id}`);
  }

  getBondedStockItems(id: string): Observable<StockItemHeader[]> {
    return this.httpService.get<StockItemHeader[]>(`${this.apiUrl}/GetBondedStockItems?id=${id}`);
  }

  getBondedStockDespatchedItems(id: string): Observable<SalesDespatchItemForStockItem[]> {
    return this.httpService.get<SalesDespatchItemForStockItem[]>(`${this.apiUrl}/GetBondedStockDespatchedItems/${id}`);
  }

  /** Moves all the batch's stock that is still in stock (balance > 0) to a location. Returns the count moved. */
  setBatchLocation(model: { bondedStockId: string; locationId: string }): Observable<number> {
    return this.httpService.post<number>(`${this.apiUrl}/SetBatchLocation`, model);
  }

  checkBondedBatchQuantity(batchNo: string): Observable<boolean> {
    return this.httpService.get<boolean>(`${this.apiUrl}/CheckBondedBatchQuantity?batchNo=${batchNo}`);
  }

  bondedStockAnalysis(fromDate: Date, toDate: Date): Observable<BondedStockAnalysis[]> {
    return this.httpService.get<BondedStockAnalysis[]>(
      `${this.apiUrl}/BondedStockAnalysis?fromDate=${fromDate.toISOString()}&toDate=${toDate.toISOString()}`,
    );
  }

  unBondedStockAnalysis(fromDate: Date, toDate: Date): Observable<UnBondedStockAnalysis[]> {
    return this.httpService.get<UnBondedStockAnalysis[]>(
      `${this.apiUrl}/UnBondedStockAnalysis?fromDate=${fromDate.toISOString()}&toDate=${toDate.toISOString()}`,
    );
  }

  amendedStock(model: StockItemHeader): Observable<any> {
    return this.httpService.post(`${this.apiUrl}/AmendedStock`, model);
  }
}
